<template>
  <div>
    <div
      v-if="
        !$route.path.includes('login/signup/bis/me') &&
          !$route.path.includes('login/signup/bis/co') &&
          !$route.name.includes('buyers-guide-title-transfer') &&
          !$route.name.includes('buyers-guide-move-in') &&
          !$route.name.includes('buyers-guide-financing-scheme-payments') &&
          !$route.name.includes('buyers-guide-billing') &&
          !$route.path.includes('buyers-guide-front-page')
      "
      class="relative bg-cover bg-center py-2 h-[200px] sm:h-[65.28px]"
      style="background-image: url('/images/background_header.png');"
    >
      <div class="absolute inset-0 bg-black opacity-50 "></div>
      <div class="flex-none sm:flex sm:justify-between items-center relative">
        <!-- logo  -->
        <div class="w-full sm:!w-[200px] text-center">
          <template>
            <button class="outline-none focus:outline-none" @click="homePage">
              <img
                title="Home Page"
                class="md:w-24 w-24 ml-6"
                src="../assets/images/logo2.png"
                alt=""
              />
            </button>
          </template>
        </div>
        <!-- title  -->
        <div>
          <div
            v-if="myRole == 1"
            class="text-[16pt] font-noto-sans tracking-[5px]"
          >
            BUYERS PORTAL ADMIN
          </div>
          <div
            v-else
            class="text-white font-bold leading-loose tracking-wide font-noto-sans text-[16pt]  text-center"
          >
            MOLDEX BUYER'S PORTAL
          </div>
        </div>

        <!-- right side  -->
        <div>
          <div class="flex items-center justify-center sm:justify-end">
            <div class="flex justify-end items-center space-y-4 sm:space-y-0">
              <div
                class="hidden sm:block relative items-center justify-center w-[32px]"
              >
                <div
                  v-if="$route.path.includes('/home')"
                  class="relative cursor-pointer"
                  @click="onPressCount"
                >
                  <!-- Badge with Notification Count -->
                  <template v-if="show">
                    <div
                      class="absolute top-0 right-0 w-[16px] h-[16px] bg-red-600 rounded-full flex items-center justify-center text-xs z-10"
                    >
                      {{ countTickets }}
                    </div>
                    <!-- Bell Icon -->
                    <v-icon color="white" class="text-lg">mdi-bell</v-icon>
                  </template>
                </div>
              </div>
              <div v-if="$route.path.includes('/home')">
                <v-btn
                  color="white"
                  small
                  text
                  @click="onPressMyAccount('My Account')"
                  v-if="myRole == 2"
                >
                  <v-icon color="white">mdi-account-outline</v-icon>
                  <span :class="classText">My Account</span></v-btn
                >
              </div>
              <div>
                <v-btn
                  color="white"
                  small
                  text
                  @click="onPressSettings"
                  v-if="myRole == 1"
                >
                  <span :class="classText" @click="newEmail">
                    New Email
                  </span></v-btn
                >
              </div>
              <div>
                <v-btn
                  color="white"
                  small
                  text
                  @click="onPressSettings"
                  v-if="myRole == 1"
                >
                  <v-icon small>mdi-tools</v-icon>
                  <span :class="classText">
                    Settings
                  </span></v-btn
                >
              </div>
              <div>
                <v-btn color="white" text small @click="signout">
                  <img
                    src="/icons/signout.png"
                    alt="signout"
                    class="w-[24px]"
                  />
                  <span :class="classText">Sign out</span></v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-[#ED7D31] h-[3pt]"></div>

    <v-dialog
      v-model="newEmailDialog"
      scrollable
      persistent
      :overlay="false"
      transition="dialog-transition"
    >
      <NewEmail @close_email_dialog="newEmailDialog = false" />
    </v-dialog>
  </div>
</template>
<script>
import NewEmail from "../components/MiniToolBar-Email.vue";
import axios from "axios";
import logout from "../utils/logout";
import SecureStorage from "../utils/secureStorage";

export default {
  data() {
    return {
      classText: "text-[9pt] font-bold font-calibri",
      show: true,
      myRole: null,
      countTickets: null,
      newEmailDialog: false,
    };
  },
  components: { NewEmail: NewEmail },
  watch: {
    "$route.path": {
      handler() {
        const role = SecureStorage.getItem("auth")?.role;
        this.myRole = role === "client" ? "2" : "1";
        this.getCountTickets();
      },
      immediate: true,
    },
  },
  methods: {
    newEmail() {
      this.newEmailDialog = true;
    },
    onPressCount() {
      this.$router.push({
        name: "Home Dashboard",
        query: {
          cc: this.$route.query.cc,
          cn: this.$route.query.cn,
        },
      });
    },
    getCountTickets() {
      const authData = SecureStorage.getItem("auth");

      let data = {
        user_id: authData.userId,
      };

      axios.post("/tickets/count", data).then((res) => {
        this.countTickets = res.data[0].count;
        this.show = this.countTickets > 0 ? true : false;
      });
    },
    onPressMyAccount(item) {
      if (this.$route.name === item) {
        return;
      } else {
        this.$router.push({
          name: "My Account",
          query: {
            cc: this.$route.query.cc,
            cn: this.$route.query.cn,
          },
        });
      }
    },
    onPressSettings() {
      if (this.$route.path !== "/home/settings/users") {
        this.$router.push("/home/settings/users");
      }
    },
    signout() {
      logout();
    },
    homePage() {
      const myRole = SecureStorage.getItem("auth").role;
      if (this.myRole == 2) {
        if (this.$route.query.cn != null || this.$route.query.cn == "") {
          if (myRole == "admin") {
            if ("/admin" != this.$route.path) {
              this.$router.push({ name: "Admin Page" });
            }
          } else {
            if ("/home/dashboard" != this.$route.path) {
              this.$router.push({
                path: "/home/dashboard",
                query: {
                  cc: this.$route.query.cc,
                  cn: this.$route.query.cn,
                },
              });
            }
          }
        } else {
          alert("Please choose a contract");
        }
      } else {
        this.$router.push("/admin/admin-dashboard-screen/unassigned-tickets");
      }
    },
  },
};
</script>
